import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "container"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "join_us_title"
}, "Join Us", -1);

var _hoisted_3 = {
  class: "job_title"
};
var _hoisted_4 = {
  class: "job_time"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_line"
}, null, -1);

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_describe"
}, "Job Description", -1);

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_duty"
}, "DUTIES & RESPONSIBILITES：", -1);

var _hoisted_8 = ["innerHTML"];

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_duty"
}, "JOB REQUIREMENTS：", -1);

var _hoisted_10 = ["innerHTML"];

var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_line"
}, null, -1);

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_info"
}, "Job Information", -1);

var _hoisted_13 = {
  class: "job_info_list"
};
var _hoisted_14 = {
  class: "job_time_02"
};
var _hoisted_15 = {
  class: "job_time_02"
};
var _hoisted_16 = {
  class: "job_time_02"
};
var _hoisted_17 = {
  class: "job_time_02"
};

var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_message"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "job_join_line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "job_join_title"
}, "Online Message")], -1);

var _hoisted_19 = {
  class: "job_input"
};

var _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "job_xing"
}, "*", -1);

var _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "job_xing"
}, "*", -1);

var _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "job_xing"
}, "*", -1);

var _hoisted_23 = /*#__PURE__*/_createTextVNode("Click to upload");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_upload = _resolveComponent("el-upload");

  var _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString($setup.jobDetail.jobTitle), 1), _createElementVNode("div", _hoisted_4, " Release time：" + _toDisplayString($setup.jobDetail.releaseDate), 1), _hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("div", {
    innerHTML: $setup.jobDetail.jobDuty
  }, null, 8, _hoisted_8), _hoisted_9, _createElementVNode("div", {
    innerHTML: $setup.jobDetail.jobRequest
  }, null, 8, _hoisted_10), _hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, "Released On：" + _toDisplayString($setup.jobDetail.releaseDate), 1), _createElementVNode("div", _hoisted_15, "Job category：" + _toDisplayString($setup.jobDetail.jobCategory), 1), _createElementVNode("div", _hoisted_16, "Number of Recruits：" + _toDisplayString($setup.jobDetail.recruitNum), 1), _createElementVNode("div", _hoisted_17, "Workplace：" + _toDisplayString($setup.jobDetail.workPlace), 1)]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_form, {
    ref: "formRef",
    model: $setup.messageForm,
    "label-width": "auto",
    class: "demo-ruleForm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "name",
        "require-asterisk-position": "right",
        "hide-required-asterisk": false,
        rules: $setup.rules.name
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.messageForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $setup.messageForm.name = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "Your Name"
          }, null, 8, ["modelValue"]), _hoisted_20];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "phone",
        rules: $setup.rules.phone
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.messageForm.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $setup.messageForm.phone = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "Your Phone"
          }, null, 8, ["modelValue"]), _hoisted_21];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "phone",
        rules: $setup.rules.email
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.messageForm.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return $setup.messageForm.email = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "Your Email"
          }, null, 8, ["modelValue"]), _hoisted_22];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
        prop: "pdf"
      }, {
        default: _withCtx(function () {
          return [$setup.fileList.length === 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "job_up_notes",
            onClick: _cache[3] || (_cache[3] = function () {
              return $setup.upNotesClk && $setup.upNotesClk.apply($setup, arguments);
            })
          }, "Click to Upload Resume")) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "job_up_notes",
            onClick: _cache[4] || (_cache[4] = function () {
              return $setup.upNotesClk && $setup.upNotesClk.apply($setup, arguments);
            })
          }, "Resume selected"))];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "job_up_btn",
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return $setup.submitForm($setup.formRef);
            })
          }, "Submit")];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]), _createVNode(_component_el_upload, {
    "file-list": $setup.fileList,
    "onUpdate:file-list": _cache[6] || (_cache[6] = function ($event) {
      return $setup.fileList = $event;
    }),
    class: "upload-demo",
    "auto-upload": false,
    ref: "uploadRef",
    action: "https://www.tenacia.com/api/actionApi/jobs/uploadResume",
    "on-change": $setup.handleChange,
    "on-success": $setup.successFun
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        ref: "upLoadBtn",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_hoisted_23];
        }),
        _: 1
      }, 512)];
    }),
    _: 1
  }, 8, ["file-list", "on-change", "on-success"])])), [[_directive_loading, $setup.loading]]);
}